import { Box, BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";

interface IconBoxProps extends BoxProps {
  children: ReactNode;
}

const IconBox = (props: IconBoxProps) => {
  const { children, ...rest } = props;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="md"
      {...rest}
    >
      {children}
    </Box>
  );
};

export default IconBox;
